import { useState } from 'react';
import { ComplexInlineHelpProps } from './types';

const ComplexInlineHelp = (props: ComplexInlineHelpProps) => {
    const { id, title, inlineHelp } = props;
    const [inlineHelpOpen, setInlineHelpOpen] = useState<boolean>(false);
    const helpId = inlineHelp ? `${id}` : undefined;

    const onInlineHelpClick = (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
        e.preventDefault();
        if (inlineHelpOpen === false) {
            setInlineHelpOpen(true);
        } else {
            setInlineHelpOpen(false);
        }
    };

    const inlineHelpClass = () => {
        if (inlineHelpOpen) {
            return 'contextual-help-dropdown active';
        }
        return 'contextual-help-dropdown';
    };

    return (
        <a
            id={helpId}
            onClick={onInlineHelpClick}
            href='#0'
            role='button'
            className='contextual-help-link'
            aria-expanded={inlineHelpOpen ? 'true' : 'false'}
        >
            <div className={inlineHelpClass()}>
                <div className='contextual-help-dropdown-title'>
                    <i className='icon-chevron-right me-1' aria-hidden='true' />
                    <span>{title}</span>
                </div>
                <div className='contextual-help-dropdown-content complex-answer'>
                    {inlineHelp}
                </div>
            </div>
        </a>
    );
};

export default ComplexInlineHelp;
